// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminMatchDetailsContainer{
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    background: #0C0B20;
    background-size: cover;
    padding: 16px;
    padding-bottom: 120px;
    padding-top: 64px;
    position: relative;
    color: white;
    align-items: center;
}

.adminMatchDetailsContainer .backButtonContainer{
    display: flex;
    justify-content: start;
    gap: 32px;
    align-items: center;
    margin-bottom: 16px;
    width: 100%;
    max-width: 500px;
}

.adminMatchDetailsContainer .backButtonContainer button{
    background: none;
    color: white;
    font-size: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
}

.adminMatchDetailsContainer h3{
    margin-bottom: 8px;
    text-align: center;
}
.adminMatchDetailsContainer p{
    text-align: center;
}

.adminMatchDetailsContainer .matchForm{
    width: 100%;
    display: flex;
    margin-top: 16px;
    flex-direction: column;
    align-items: center;
}

.adminMatchDetailsContainer .matchForm form{
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
    max-width: 500px;
}

.adminMatchDetailsContainer .matchForm form .formGroup{
    display: flex;
    flex-direction: column;
    gap: 8px;
}


.adminMatchDetailsContainer .matchForm form .formGroup input, .adminMatchDetailsContainer .matchForm form .formGroup select{
    padding: 8px;
    font-size: 32px;
}

.adminMatchDetailsContainer .matchForm form .formGroup select{
    font-size: 14px;
}

.adminMatchDetailsContainer .matchForm form .formGroup:nth-child(1){
    display: flex;
    flex-direction: row;
    gap: 8px;
}

.adminMatchDetailsContainer .matchForm form .formGroup:nth-child(1) label{
    text-align: center;
    font-weight: bold;
    letter-spacing: 1.5px;
    width: 100%;
}

.adminMatchDetailsContainer .matchForm form .formGroup div{
    display: flex;
    flex-direction: column;
    width: 50%;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.adminMatchDetailsContainer .matchForm form .formGroup input{
    width: 50px;
    border-radius: 16px;
    border: none;
    text-align: center;
    width: 50%;
    padding-left: 16px;
}

.adminMatchDetailsContainer .matchForm form .formGroup input#matchDate{
    width: 100%;
    font-size: 16px;
    text-align: start;
    padding: 16px;
}

.adminMatchDetailsContainer .matchForm form button{
    padding: 8px;
    border-radius: 8px;
    border: none;
    background: forestgreen;
    color: white;
    font-size: 16px;
    margin-top: 8px;
}

.adminMatchDetailsContainer .matchForm form .message{
    width: 100%;
    background: #5353536c;
    padding: 16px;
    border-radius: 8px;
    font-weight: bold;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/AdminDashboard/Tournament/Matches/AdminTournamentMatchesDetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;;AAGA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".adminMatchDetailsContainer{\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    min-height: 100vh;\r\n    background: #0C0B20;\r\n    background-size: cover;\r\n    padding: 16px;\r\n    padding-bottom: 120px;\r\n    padding-top: 64px;\r\n    position: relative;\r\n    color: white;\r\n    align-items: center;\r\n}\r\n\r\n.adminMatchDetailsContainer .backButtonContainer{\r\n    display: flex;\r\n    justify-content: start;\r\n    gap: 32px;\r\n    align-items: center;\r\n    margin-bottom: 16px;\r\n    width: 100%;\r\n    max-width: 500px;\r\n}\r\n\r\n.adminMatchDetailsContainer .backButtonContainer button{\r\n    background: none;\r\n    color: white;\r\n    font-size: 32px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border: none;\r\n}\r\n\r\n.adminMatchDetailsContainer h3{\r\n    margin-bottom: 8px;\r\n    text-align: center;\r\n}\r\n.adminMatchDetailsContainer p{\r\n    text-align: center;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm{\r\n    width: 100%;\r\n    display: flex;\r\n    margin-top: 16px;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm form{\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    gap: 8px;\r\n    max-width: 500px;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm form .formGroup{\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n\r\n.adminMatchDetailsContainer .matchForm form .formGroup input, .adminMatchDetailsContainer .matchForm form .formGroup select{\r\n    padding: 8px;\r\n    font-size: 32px;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm form .formGroup select{\r\n    font-size: 14px;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm form .formGroup:nth-child(1){\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 8px;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm form .formGroup:nth-child(1) label{\r\n    text-align: center;\r\n    font-weight: bold;\r\n    letter-spacing: 1.5px;\r\n    width: 100%;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm form .formGroup div{\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 50%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm form .formGroup input{\r\n    width: 50px;\r\n    border-radius: 16px;\r\n    border: none;\r\n    text-align: center;\r\n    width: 50%;\r\n    padding-left: 16px;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm form .formGroup input#matchDate{\r\n    width: 100%;\r\n    font-size: 16px;\r\n    text-align: start;\r\n    padding: 16px;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm form button{\r\n    padding: 8px;\r\n    border-radius: 8px;\r\n    border: none;\r\n    background: forestgreen;\r\n    color: white;\r\n    font-size: 16px;\r\n    margin-top: 8px;\r\n}\r\n\r\n.adminMatchDetailsContainer .matchForm form .message{\r\n    width: 100%;\r\n    background: #5353536c;\r\n    padding: 16px;\r\n    border-radius: 8px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
